var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAttach = function SvgAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "attach-ico-a",
    d: "M16.018 11.861l-1.149-1.183-5.168-5.325a2.386 2.386 0 00-3.44.007 2.564 2.564 0 00-.006 3.543l5.168 5.326a.53.53 0 00.766 0 .57.57 0 000-.789L7.021 8.114a1.424 1.424 0 010-1.972 1.326 1.326 0 011.914 0l5.17 5.325 1.149 1.183c.951.98.95 2.57-.001 3.55a2.387 2.387 0 01-3.447 0l-.957-.986-5.36-5.522-.383-.395C3.768 7.875 3.785 5.61 5.144 4.21a3.447 3.447 0 014.94-.04l5.742 5.917a.53.53 0 00.523.145.55.55 0 00.383-.395.57.57 0 00-.14-.539L10.85 3.381a4.507 4.507 0 00-6.5.008c-1.797 1.848-1.8 4.845-.01 6.697l5.742 5.917.959.986a3.447 3.447 0 004.927-.051 3.706 3.706 0 00.049-5.077z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "attach-ico-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#attach-ico-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#attach-ico-a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    mask: "url(#attach-ico-b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5-5h30v30H-5z"
  })))));
};
export default SvgAttach;